/* ==========================================================================
   Horma Real — piezas del carrito "estilo Zavatty", compartidas por el cajón
   (assets/hr-lf-cart.js) y la página del carrito (sections/hr-v2-cart.liquid).

   1. Aviso con cuenta regresiva. La de Zavatty es falsa: vuelve a 30:00 cada
      vez que se recarga la página. La nuestra cuenta hasta el CORTE DE
      DESPACHO real —4 p. m. de lunes a viernes, 12 del mediodía el sábado, sin
      domingos ni festivos—, las mismas reglas de snippets/hr-entrega.liquid y
      de la política de envíos. Si cambia el corte, cambiarlo en los dos sitios.
      Con productos de proveedor (Dropi, etiqueta "dropi" o "dropi-…") no hay
      "sale hoy": se muestra el plazo de 3 a 6 días hábiles de su plantilla.
   2. Barra de envío gratis con rayas en movimiento (umbral = tarifa de Shopify).
   3. Recomendados con estrellas y colores, pintados por sections/hr-cart-reco.
   ========================================================================== */
(function () {
  if (window.HRZ) return;
  var DIA = 864e5, CORTE = 16, CORTE_SAB = 12;
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  /* ---------- Corte de despacho (hora de Bogotá, UTC−5) ---------- */
  var cacheF = {};
  function festivos(y) {
    if (cacheF[y]) return cacheF[y];
    var f = {};
    function marca(t) { f[t] = 1; }
    function lunes(t) { var w = new Date(t).getUTCDay(); return w === 1 ? t : t + ((8 - w) % 7) * DIA; }
    [[1, 1], [5, 1], [7, 20], [8, 7], [12, 8], [12, 25]].forEach(function (x) { marca(Date.UTC(y, x[0] - 1, x[1])); });
    [[1, 6], [3, 19], [6, 29], [8, 15], [10, 12], [11, 1], [11, 11]].forEach(function (x) { marca(lunes(Date.UTC(y, x[0] - 1, x[1]))); });
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, g = Math.floor((b + 8) / 25),
        h = Math.floor((b - g + 1) / 3), i = (19 * a + b - d - h + 15) % 30, k = Math.floor(c / 4), l = c % 4,
        L = (32 + 2 * e + 2 * k - i - l) % 7, m = Math.floor((a + 11 * i + 22 * L) / 451),
        pascua = Date.UTC(y, Math.floor((i + L - 7 * m + 114) / 31) - 1, ((i + L - 7 * m + 114) % 31) + 1);
    [-3, -2, 43, 64, 71].forEach(function (n) { marca(pascua + n * DIA); });   // jue/vie santo, Ascensión, Corpus, S. Corazón
    return (cacheF[y] = f);
  }
  // Despachamos de lunes a sábado (política de envíos): solo el domingo y los festivos no cuentan.
  function habil(t) { return new Date(t).getUTCDay() !== 0 && !festivos(new Date(t).getUTCFullYear())[t]; }
  function despacho() {
    var a = new Date(Date.now() - 5 * 3600e3);                       // Bogotá, leída con getUTC*
    var hoy = Date.UTC(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate());
    var corte = (new Date(hoy).getUTCDay() === 6 ? CORTE_SAB : CORTE) * 3600;
    var seg = a.getUTCHours() * 3600 + a.getUTCMinutes() * 60 + a.getUTCSeconds();
    var saleHoy = habil(hoy) && seg < corte;
    var sale = hoy;
    if (!saleHoy) { do { sale += DIA; } while (!habil(sale)); }
    return { saleHoy: saleHoy, quedan: saleHoy ? corte - seg : 0,
             cuando: sale === hoy + DIA ? 'mañana' : 'el ' + DIAS[new Date(sale).getUTCDay()] };
  }

  /* ---------- Aviso (píldora) ---------- */
  var IC = {
    fuego: '<svg class="hrz-fuego" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path class="hrz-fuego__a" d="M12.3 2c.9 3.3-1.5 5.1-3 7.2C7.8 11.3 7 13 7 14.9a5.4 5.4 0 0 0 10.8 0c0-2.5-1.3-4.5-2.5-5.9-.2 1.6-.9 2.6-2 3.1.4-3.5-.4-7.5-1-10.1Z"/><path class="hrz-fuego__b" d="M12.4 21a2.9 2.9 0 0 1-2.9-2.9c0-1.5 1.1-2.5 2-3.5.3 1 .9 1.6 1.6 1.8.1-.8.4-1.4.9-1.9.7.9 1.3 2 1.3 3.1A2.9 2.9 0 0 1 12.4 21Z"/></svg>',
    camion: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>'
  };
  function dos(n) { return n < 10 ? '0' + n : '' + n; }
  function reloj(s) { return dos(Math.floor(s / 3600)) + ':' + dos(Math.floor(s % 3600 / 60)) + ':' + dos(s % 60); }

  var pildoras = [];
  function pintaPildora(el) {
    var st = el._hrz;
    if (!st || st.proveedor === null) { el.hidden = true; return; }
    var d = despacho(), modo, html;
    if (st.proveedor) {
      modo = 'prov';
      html = IC.camion + '<span>Su pedido llega en <b>3 a 6 días hábiles</b>.</span>';
    } else if (d.saleHoy) {
      modo = 'hoy';
      html = IC.fuego + '<span>¡Pida ya y su pedido <b>sale hoy</b>! Quedan <b class="hrz-pill__reloj" data-hrz-reloj>' + reloj(d.quedan) + '</b></span>';
    } else {
      modo = 'manana';
      html = IC.camion + '<span>Pida hoy y su pedido sale <b>' + d.cuando + ' a primera hora</b>.</span>';
    }
    if (st.modo !== modo) {
      el.innerHTML = html;
      el.classList.remove('hrz-pill--prov', 'hrz-pill--hoy', 'hrz-pill--manana');
      el.classList.add('hrz-pill--' + modo);
      st.modo = modo;
    } else if (modo === 'hoy') {
      var r = el.querySelector('[data-hrz-reloj]');
      if (r) r.textContent = reloj(d.quedan);
    }
    el.hidden = false;
  }
  setInterval(function () { pildoras.forEach(pintaPildora); }, 1000);

  /* ¿Algún producto lo despacha un proveedor? /products/<handle>.js trae las etiquetas.
     Se guarda en memoria y en sessionStorage para no repetir la consulta. */
  var provCache = {};
  function esProveedor(handle) {
    if (provCache.hasOwnProperty(handle)) return Promise.resolve(provCache[handle]);
    try {
      var s = sessionStorage.getItem('hrz-prov:' + handle);
      if (s === '1' || s === '0') return Promise.resolve(provCache[handle] = s === '1');
    } catch (e) {}
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var v = (p.tags || []).some(function (t) { t = String(t).toLowerCase(); return t === 'dropi' || t.indexOf('dropi-') === 0; });
        provCache[handle] = v;
        try { sessionStorage.setItem('hrz-prov:' + handle, v ? '1' : '0'); } catch (e) {}
        return v;
      })
      .catch(function () { return false; });
  }

  /* pildora(el, items)          → cajón: items de /cart.js (averigua si hay productos de proveedor)
     pildora(el, null, true|false) → página: ya se sabe desde Liquid */
  function pildora(el, items, proveedor) {
    if (!el) return;
    if (pildoras.indexOf(el) === -1) pildoras.push(el);
    el._hrz = el._hrz || { proveedor: null, modo: null };
    if (typeof proveedor === 'boolean') { el._hrz.proveedor = proveedor; pintaPildora(el); return; }
    if (!items || !items.length) { el._hrz.proveedor = null; el._hrz.token = ''; el.hidden = true; return; }
    var hs = items.map(function (i) { return i.handle; }).filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    var token = hs.join(',');
    if (el._hrz.token === token && el._hrz.proveedor !== null) { pintaPildora(el); return; }
    el._hrz.token = token;
    Promise.all(hs.map(esProveedor)).then(function (vs) {
      if (el._hrz.token !== token) return;          // el carrito cambió mientras tanto
      el._hrz.proveedor = vs.some(Boolean);
      pintaPildora(el);
    });
  }

  /* ---------- Barra de envío gratis ---------- */
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); }
  /* envio(el, total, umbral, items, alCambiar): gratis desde el umbral (tarifa de Shopify). Desde el 17-oct-2026 los
     productos de Dropi siguen la misma regla (antes su perfil de envío era gratis siempre).
     Si no llega, dice cuánto cuesta el envío y, si la plantilla alcanza, la sugiere (HR_LFC_CFG).
     28-oct-2026: la plantilla es del local; si el carrito trae algo de Dropi NO se sugiere, porque saldría en otro
     paquete (pedido #1251: zapato de Dropi + plantilla para llegar al envío gratis). Mientras no se sabe, tampoco. */
  function pintaEnvio(el, gratis, totalCents, umbralCents) {
    var cfg = window.HR_LFC_CFG || {};
    el._hrzUlt = [gratis, totalCents, umbralCents];
    var tx = el.querySelector('[data-hrz-envio-tx]'), bar = el.querySelector('[data-hrz-envio-bar]');
    var pct = gratis ? 100 : Math.max(6, Math.min(96, Math.round(totalCents * 100 / umbralCents)));
    var falta = umbralCents - totalCents, extra = '';
    if (!gratis) {
      var costo = cfg.minimo && totalCents < cfg.minimo ? cfg.tarifaMin : cfg.tarifa;
      if (cfg.plantilla && cfg.plantilla.precio && falta <= cfg.plantilla.precio && el._hrzProv === false) extra = ' <a href="' + cfg.plantilla.url + '">Agregue una plantilla de ' + money(cfg.plantilla.precio) + '</a> y le sale gratis.';
      else if (costo) extra = ' Si no, el envío cuesta ' + money(costo) + '.';
    }
    if (tx) tx.innerHTML = gratis
      ? '<b>¡FELICIDADES!</b> Su envío es <b>gratis</b> a toda Colombia.'
      : 'Le faltan <b>' + money(falta) + '</b> para tener <b>envío gratis</b>.' + extra;
    if (bar) bar.style.width = pct + '%';
    el.classList.toggle('is-gratis', gratis);
    document.querySelectorAll('[data-hrz-ben-envio]').forEach(function (b) {
      if (!b._hrzOrig) b._hrzOrig = b.innerHTML;
      b.innerHTML = gratis ? '<b>Envío gratis a toda Colombia</b><small>Su pedido ya tiene el envío gratis.</small>' : b._hrzOrig;
    });
  }
  /* Excepción (17-oct-2026): etiqueta envio-gratis = perfil de envío propio gratis (Sueco en malla de los anuncios). */
  var egCache = {};
  function esEnvioGratis(handle) {
    if (egCache.hasOwnProperty(handle)) return Promise.resolve(egCache[handle]);
    try {
      var s = sessionStorage.getItem('hrz-eg:' + handle);
      if (s === '1' || s === '0') return Promise.resolve(egCache[handle] = s === '1');
    } catch (e) {}
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var v = (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'envio-gratis'; });
        egCache[handle] = v;
        try { sessionStorage.setItem('hrz-eg:' + handle, v ? '1' : '0'); } catch (e) {}
        return v;
      })
      .catch(function () { return false; });
  }
  function envio(el, totalCents, umbralCents, items, alCambiar) {
    var gratis = !umbralCents || totalCents >= umbralCents;
    var hsP = (items || []).map(function (i) { return i.handle; }).filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    var tokP = hsP.join(',');
    if (el && el._hrzProvTok !== tokP) { el._hrzProvTok = tokP; el._hrzProv = null; }
    if (el) pintaEnvio(el, gratis, totalCents, umbralCents);
    if (el && hsP.length && el._hrzProv === null) {
      Promise.all(hsP.map(esProveedor)).then(function (vs) {
        if (el._hrzProvTok !== tokP) return;             // el carrito cambió mientras tanto
        el._hrzProv = vs.some(Boolean);
        if (el._hrzUlt) pintaEnvio(el, el._hrzUlt[0], el._hrzUlt[1], el._hrzUlt[2]);
      });
    }
    /* Shopify cobra cada perfil por separado: si hay productos con envío gratis propio, el umbral se mide con lo demás. */
    if (umbralCents && items && items.length) {
      var hs = items.map(function (i) { return i.handle; }).filter(function (h, i, a) { return h && a.indexOf(h) === i; });
      var tok = hs.join(',') + ':' + totalCents;
      if (el) el._hrzEnvio = tok;
      Promise.all(hs.map(esEnvioGratis)).then(function (vs) {
        if (el && el._hrzEnvio !== tok) return;
        var libres = {};
        hs.forEach(function (h, i) { if (vs[i]) libres[h] = true; });
        if (!Object.keys(libres).length) return;
        var base = items.reduce(function (s, it) { return s + (libres[it.handle] ? 0 : (it.final_line_price || it.line_price || 0)); }, 0);
        var g2 = base === 0 || base >= umbralCents;
        if (el) pintaEnvio(el, g2, base, umbralCents);
        if (alCambiar && g2 !== gratis) alCambiar(g2);
      });
    }
    return gratis;
  }

  /* ---------- Recomendados (Section Rendering API) ---------- */
  function flechas(caja) {
    if (caja._hrzFlechas) return;
    caja._hrzFlechas = true;
    var fila = caja.querySelector('[data-hrz-reco-row]');
    caja.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hrz-reco-nav]');
      if (!b || !fila) return;
      var paso = Math.max(160, fila.clientWidth * 0.9) * (b.getAttribute('data-hrz-reco-nav') === 'prev' ? -1 : 1);
      fila.scrollBy({ left: paso, behavior: 'smooth' });
    });
  }
  function reco(caja, pid, opts) {
    if (!caja || !pid) return;
    var fila = caja.querySelector('[data-hrz-reco-row]');
    if (!fila) return;
    opts = opts || {};
    var excluir = (opts.excluir || []).map(String);
    fetch('/recommendations/products?section_id=hr-cart-reco&product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = [].slice.call(doc.querySelectorAll('.hrz-rc'))
          .filter(function (c) { return excluir.indexOf(c.getAttribute('data-pid')) === -1; })
          .slice(0, opts.limite || 8);
        if (!cards.length) { caja.hidden = true; return; }
        fila.innerHTML = '';
        cards.forEach(function (c) {
          /* El cajón escribe los precios con punto ($169.900); Liquid los trae con coma ($169,900). */
          if (opts.puntos) c.querySelectorAll('.hrz-rc__p s, .hrz-rc__p span').forEach(function (n) { n.textContent = n.textContent.replace(/,(\d{3})/g, '.$1'); });
          fila.appendChild(document.importNode(c, true));
        });
        caja.hidden = false;
        flechas(caja);
      })
      .catch(function () { caja.hidden = true; });
  }
  // Tocar un color cambia la foto de la tarjeta y lleva el enlace a esa variante.
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.hrz-rc__sw');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.hrz-rc');
    if (!card) return;
    var img = card.querySelector('.hrz-rc__img');
    if (img && sw.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-img'); }
    if (sw.getAttribute('data-url')) card.querySelectorAll('a[href]').forEach(function (a) { a.href = sw.getAttribute('data-url'); });
    card.classList.add('is-color');
    card.querySelectorAll('.hrz-rc__sw').forEach(function (b) {
      b.classList.toggle('is-sel', b === sw);
      b.setAttribute('aria-pressed', b === sw ? 'true' : 'false');
    });
  });

  window.HRZ = { despacho: despacho, pildora: pildora, envio: envio, reco: reco, money: money, esEnvioGratis: esEnvioGratis };
})();
